import styled from 'styled-components';
import {ellipsisLines, dFlex, dFlexCenter, dFlexSpaceBetween, mobileMedia}
    from '../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';

export const dragIcon = styled.div`
    width: 24px;
    height: 24px;
    ${dFlexCenter}
`;

export const dragHandle = styled.div`
    width: 0;
    flex-shrink: 0;
    overflow: hidden;
    align-self: stretch;
    ${dFlexCenter};
    transition: width 0.15s;
    touch-action: none;
    cursor: grab;
    ${mobileMedia} {
        width: 32px;
    }
`;

export const container = styled.div<{ $expanded?: boolean; $isDragging?: boolean }>`
    width: 305px;
    flex-shrink: 0;
    height: ${p => p.$expanded ? '191px' : 'unset'};
    min-height: ${p => p.$expanded ? 'unset' : '72px'};
    ${dFlex};
    background: var(--TA-color-bg-base);
    border-radius: 4px;
    border: 1px solid var(--TA-color-border-subtle);
    overflow: hidden;
    opacity: ${p => p.$isDragging ? 0 : 1};
    //transform: var(--dnd-transform, none);
    &:hover ${dragHandle} {
        width: 32px;
    }
    ${mobileMedia} {
        width: 100%;
        height: unset;
        min-height: 72px;
    }
`;

export const content = styled.div<{ $expanded?: boolean }>`
    flex: 1;
    ${dFlexSpaceBetween};
    align-items: flex-start;
    min-width: 0;
    padding-block: ${p => p.$expanded ? '16px' : '12px 8px'};
    padding-inline: var(--space-sm) var(--space-lg);
`;

export const details = styled.div`
    flex: 1;
    ${dFlex};
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const title = styled.div<{ $expanded?: boolean }>`
    font-weight: ${tokens.typography.fontWeight.bold};
    font-size: 16px;
    line-height: 16px;
    min-height: ${p => p.$expanded ? '32px' : '16px'};
    color: var(--TA-color-text-default);
    text-align: start;
    width: 100%;
    ${p => ellipsisLines(p.$expanded ? 2 : 1)}
`;

export const ticketInfo = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ticketDetails = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: 0;
`;

export const detailText = styled.div`
    font-size: ${tokens.typography.fontSize.caption};
    font-weight: ${tokens.typography.fontWeight.bold};
    color: var(--TA-color-text-default);
    text-align: start;
    line-height: 140%;
`;

export const detailLabel = styled.span`
    font-weight: ${tokens.typography.fontWeight.regular};
`;
